module.exports = __webpack_public_path__ + "img/mainsystems.eb46345f.png";